import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69bd3301"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "province" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Header, {
      title: "Add Address",
      backgroundColor: "#424040",
      fontColor: "#fff",
      skipPath: "/"
    }),
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.provinceList, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.area_id,
          onClick: ($event: any) => ($setup.pitchLevel(item))
        }, [
          _createTextVNode(_toDisplayString(item.area_name) + " ", 1),
          ($setup.usete.query.current_id == item.area_id)
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 0,
                name: "success"
              }))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2))
      }), 128))
    ])
  ]))
}